@for (filter of gridFilterGroup.filters; track trackByGridFilter(idx, filter); let idx = $index) { @if
(filter.facetIsCrawlable) {

<a
    [href]="getFacetURL(filter, gridFilterGroup.facetUrlParameterName)"
    [attr.aria-label]="getAriaLabel(filter)"
    (click)="addFilterCrawlableLinks($event, filter)"
    tabindex="-1"
    (keydown.space)="addFilterCrawlableLinks($event, filter)"
    [attr.data-test-id]="gridFilterGroup.facetUrlParameterName + '_' + idx">
    <ng-container
        [ngTemplateOutlet]="checkboxFilter"
        [ngTemplateOutletContext]="{
                    gridFilterGroup,
                    filter,
                }">
    </ng-container>
</a>

} @else {

<ng-container
    [ngTemplateOutlet]="checkboxFilter"
    [ngTemplateOutletContext]="{
                gridFilterGroup,
                filter,
            }">
</ng-container>

} }

<ng-template #checkboxFilter let-gridFilterGroup="gridFilterGroup" let-filter="filter">
    <h-checkbox
        [id]="filter | gridFilterIdSetter : gridFilterGroup"
        [formControl]="getFormControl(filter.name)"
        [insideLabel]="true"
        (change)="handleChange(filter)">
        <span class="label">
            <span> {{ filter.name }}</span>
            <span [attr.aria-hidden]="'true'"> ({{ filter.total }}) </span>
            @if (!filter.facetIsCrawlable) {

            <span hSrOnlyNoSnippet>
                <span>, {{ filter.total }} </span>
                @if (filter.total > 1) {
                <div>
                    <span i18n="@@hermes.accessibility.items">items</span>
                </div>
                } @else {

                <span i18n="@@hermes.accessibility.item">item</span>

                }
            </span>

            }
        </span>
    </h-checkbox>
</ng-template>
